import React from 'react'
import { IPaginationPayload } from '../../../../interfaces/shared/IPaginationPayload';
import { IAssetTemplate } from '../../../../interfaces/asset-templates/IAssetTemplate';
import { IAllMarkets } from '../../../../interfaces/markets/IAllMarkets';
import { IOrders } from '../../../../interfaces/orders/IOrders';
import OpenCasesTable from '../tables/OpenCasesTable';
import OpenCasesFilters from '../details/CasesFilters';
import EmptyContainer from '../../../../shared/empty-container';


interface IRejectedFromBrokerTab {
    sectors: IAssetTemplate[]
    markets: IAllMarkets[]
    selectedMarket: string
    selectedSector: string
    assignees: any[]
    selectedAssignee: string
    orderTypes: any[]
    selectedOrderType: string
    rows: IOrders[]
    rowsLoading: boolean
    paginationData: IPaginationPayload
    accessControl: any
    searchValue: any | undefined
    setPaginationState: React.Dispatch<React.SetStateAction<IPaginationPayload>>
    onSelectFilterOption: (value: any, name?: string) => void
    onClickAction: (data: { actionName: string, id?: string, itemId?: string, country?: string, current?: any }) => void;
    onChangeSearchValue: (value: string | null | undefined, type: string) => void
    clearAllFilters: () => void;
    pageAccess: any;
}

const RejectedFromBrokerTab = ({ sectors, markets, selectedMarket, selectedSector, onSelectFilterOption, assignees, selectedAssignee, orderTypes, selectedOrderType, rows, rowsLoading, paginationData, setPaginationState, onClickAction, accessControl, searchValue, onChangeSearchValue, clearAllFilters, pageAccess }: IRejectedFromBrokerTab) => {


    return (
        <div>
            <div className='my-10'>
                <OpenCasesFilters
                    sectors={sectors}
                    markets={markets}
                    selectedMarket={selectedMarket}
                    selectedSector={selectedSector}
                    onSelectFilterOption={onSelectFilterOption}
                    assignees={assignees}
                    selectedAssignee={selectedAssignee}
                    orderTypes={orderTypes}
                    selectedOrderType={selectedOrderType}
                    searchValue={searchValue}
                    onChangeSearchValue={onChangeSearchValue}
                    clearAllFilters={clearAllFilters}
                />
            </div>
            <div className='relative'>
                {rows?.length > 0 || rowsLoading ? (
                    <OpenCasesTable
                        rows={rows}
                        actions={pageAccess?.actions}
                        accessControl={accessControl}
                        paginationData={paginationData}
                        rowsLoading={rowsLoading}
                        setPaginationState={setPaginationState}
                        onClickAction={onClickAction}
                        categories={sectors || []}
                        markets={markets || []}
                        showActions={[{ name: 'View', icon: '/assets/table-actions/view.svg' }, { name: 'Write a note', icon: '/assets/table-actions/write-a-note.svg' }, { name: 'Mark as completed', icon: '/assets/table-actions/mark-as-completed.svg' }]}
                        selectedTab='rejectedFromBroker' />)
                    : (
                        <EmptyContainer
                            text={'No case has been found.'}
                            showImage={true}
                        />
                    )}
            </div>
        </div>
    )
}

export default RejectedFromBrokerTab
